import { render } from "./PostAttachments.vue?vue&type=template&id=525a59f0&scoped=true"
import script from "./PostAttachments.vue?vue&type=script&lang=js"
export * from "./PostAttachments.vue?vue&type=script&lang=js"

import "./PostAttachments.vue?vue&type=style&index=0&id=525a59f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525a59f0"]])

export default __exports__